import $ from 'jquery';
$(document).ready(function() {
    let page = $('#event_detail');
    if (page.length > 0) {

        let getTagOG = (name, content) => {
            var content = (content == null) ? 'content' : content;
            return document.querySelector("meta[property='" + name + "']").getAttribute(content);
        }
        let getTagName = (name, content) => {
            var content = (content == null) ? 'content' : content;
            return document.querySelector("meta[name='" + name + "']").getAttribute(content);
        }

        function fbShare(url, title, descr, image) {
            window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer', 'top=20,left=20,toolbar=0,status=0,width=600,height=300,resizable=1');
        }

        function openFbPopUp() {
            fbShare(encodeURIComponent(getTagOG('og:url')), getTagOG('og:title'), getTagOG('og:description'), getTagOG('og:image'));
            return false;
        }

        function openTwPopUp() {
            window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${getTagName('twitter:title')}`, 'twitterwindow', 'left=20,top=20,width=600,height=300,toolbar=0,resizable=1');
            return false;
        }
        $(document).on('click', '.share-network-facebook', function() {
            openFbPopUp();
        });
        $(document).on('click', '.share-network-twitter', function() {
            openTwPopUp();
        });
        const listNews = $('.listNews li');
        $(document).on('click', '.showMoreInformation', function() {
            listNews.removeClass('noDisplay');
        });
    }
});
